import { render, staticRenderFns } from "./addProvider.vue?vue&type=template&id=2fc1e134&scoped=true&"
import script from "./addProvider.vue?vue&type=script&lang=js&"
export * from "./addProvider.vue?vue&type=script&lang=js&"
import style0 from "./addProvider.vue?vue&type=style&index=0&id=2fc1e134&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc1e134",
  null
  
)

export default component.exports